module.exports = __webpack_public_path__ + "img/bg.0d350bb8.png";